import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';

import App from './App';
import './index.css';

const wurzel = document.getElementById('wurzel');
if (wurzel === null) {
  throw new Error('Das Element #wurzel fehlt in der index.html.');
}

createRoot(wurzel).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Registriert den Service Worker, der die App-Huelle (die gebauten
// JS/CSS-Dateien, index.html, die Icons) zwischenspeichert. NICHT
// zwischengespeichert werden die Directus-Antworten und ausdruecklich nicht
// /konfiguration.js - beides regelt vite.config.ts.
//
// registerType: 'autoUpdate' (siehe vite.config.ts) heisst: Bei einer neuen
// Version wird im Hintergrund aktualisiert und automatisch neu geladen,
// ohne dass die Lehrkraft etwas bestaetigen muss - keine zusaetzliche
// Oberflaeche dafuer noetig.
//
// Waehrend "npm run dev" ist dieser Aufruf wirkungslos: Ohne
// devOptions.enabled in vite.config.ts liefert das virtuelle Modul dort
// keinen echten Service Worker aus. Die lokale Entwicklung bleibt dadurch
// unveraendert.
registerSW({
  immediate: true,
  onOfflineReady() {
    console.info(
      '[PWA] Die App-Huelle ist zwischengespeichert und laeuft jetzt auch ohne Internetverbindung. ' +
        'Die Inhalte selbst braucht weiterhin eine Verbindung zu Directus.',
    );
  },
  onRegisterError(fehler: unknown) {
    console.warn('[PWA] Service Worker konnte nicht registriert werden.', fehler);
  },
});
